import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-[#0D0D0D] font-inter selection:bg-[#F5C518] selection:text-[#1A1A1A]" data-id="element-172">
      <HeroSection data-id="element-173" />
      <ProblemSection data-id="element-174" />
      <MechanismSection data-id="element-175" />
      <WhatYouGetSection data-id="element-176" />
      <AudienceSection data-id="element-177" />
      <HowItWorksSection data-id="element-178" />
      <ProofSection data-id="element-179" />
      <FAQSection data-id="element-180" />
      <PricingSection data-id="element-181" />
      <Footer data-id="element-182" />
    </main>;
}